import { useContextStore } from "@/store/context";

export const useABTestFiltres = (productsListMode) => {
  const { productListFilterModePopin } = storeToRefs(useContextStore());
  const { setProductListFilterModePopin } = useContextStore();

  const filterModePopin = ref(
    productsListMode === "List"
      ? false
      : useRuntimeConfig().public.KAMELEOON_TEST_FILTRES === "NEW"
        ? true
        : !!productListFilterModePopin.value
  );

  const getABTestProductListFilters = () => {
    if (productListFilterModePopin.value !== null) {
      return productListFilterModePopin.value
    }
    if (
      process.client &&
      useRuntimeConfig().public.KAMELEOON_TEST_FILTRES_ID &&
      useRuntimeConfig().public.KAMELEOON_TEST_FILTRES === "ABTEST"
    ) {
      waitForKameleoon()
        .then(() => {
          const variation = getKameleoonExperimentVariation(
            useRuntimeConfig().public.KAMELEOON_TEST_FILTRES_ID
          );
          const isModePopin = variation && variation > 0;
          nextTick(() => {
            setProductListFilterModePopin(isModePopin);
            filterModePopin.value = isModePopin;
          })
        })
        .catch(() => { });
    }
  }

  return {
    filterModePopin,
    getABTestProductListFilters
  }
}